import React, {    } from 'react';
import Breadcrumb from '../common/Breadcrumb';
 
 
const ReportDashboard = () => {
  

  return (
    <div className="container mx-auto px-6 py-8">
  <Breadcrumb />
  <div className="flex justify-between items-center mb-8">
      <h2 className="text-2xl font-bold text-gray-900  ">Reports</h2>
    </div>
  <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
     
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Sales Revenue */}
      <section>
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Sales Revenue
        </h2>

        {[
          "All Sales Ungrouped",
          "Sales By Customer",
          "Sales By Service Tech",
          "Sales By Referral Source",
          "Estimates",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">
              Last 12 Months | This Year | Last Month | This Month | This Week | Custom
            </p>
          </div>
        ))}
      </section>

      {/* Accounting */}
      <section>
       <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Accounting
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">Invoice</h3>
          <p className="text-sm text-gray-600">Custom</p>
        </div>

        {/* Tax */}
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Tax
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">Sales Tax Report</h3>
          <p className="text-sm text-gray-600">
            Last Quarter | Last Month | This Month | This Week | Custom
          </p>
        </div>

        {/* Fees */}
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Fees
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">
            Discount/Misc Fees Report
          </h3>
          <p className="text-sm text-gray-600">
            Last Quarter | Last Month | This Month | This Week | Custom
          </p>
        </div>
      </section>

      {/* Payment & Refund Transactions */}
      <section>
      <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Payment & Refund Transactions
        </h2>
        {[
          "Transactions by Customer",
          "Transactions by Service Tech",
          "Transactions by Job",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">
              Last 12 Months | This Year | Last Month | This Month | This Week | Custom
            </p>
          </div>
        ))}

        {/* Inventory Stock Levels */}
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Inventory Stock Levels
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">
            Inventory Stock Levels By Warehouse
          </h3>
          <p className="text-sm text-gray-600">As Of Today | Custom</p>
        </div>
      </section>

      {/* List Reports */}
      <section>
      <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          List Reports
        </h2>
        {[
          "Customer List",
          "Equipment List",
          "Customer Service Locations",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">Custom</p>
          </div>
        ))}

        {/* Activity Reports */}
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Activity Reports
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">Job Activity Report</h3>
          <p className="text-sm text-gray-600">
            Last Month | Last Week | This month | This Week | Custom
          </p>
        </div>
      </section>

      {/* Payroll */}
      <section>
       <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Payroll
        </h2>
        {[
          "Hours Worked by Employee",
          "Job Drive & Labor Times",
          "Sales Commission By Agent",
          "Sales Commission By Service Tech",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">
              Last Two Weeks | Last Week | This Week | Custom
            </p>
          </div>
        ))}
      </section>

      {/* Sales by Product/Service */}
      <section>
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Sales by Product/Service
        </h2>
        {[
          "Sales of Product/Service Details",
          "Sales of Product/Service By Service Tech",
          "Estimated Sales of Product/Service Details",
          "Estimated Sales of Product/Service By Service Tech",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">
              Last Two Weeks | Last Week | This Week | Custom
            </p>
          </div>
        ))}
      </section>

      {/* Expense Reports */}
      <section>
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Expense Reports
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">
            Reimbursable Expenses by Employee
          </h3>
          <p className="text-sm text-gray-600">
            Last Two Weeks | Last Week | This Week | Custom
          </p>
        </div>
      </section>

      {/* Day Sheet */}
      <section>
        <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Day Sheet
        </h2>
        {[
          "Day Sheet By Service Tech",
          "Expanded Day Sheet By Service Tech",
          "Individual Work Orders",
        ].map((title) => (
          <div key={title} className="mb-5">
            <h3 className="text-lg font-medium text-gray-800 mb-1">{title}</h3>
            <p className="text-sm text-gray-600">
              Today | Tomorrow | Next Two Weeks | Custom
            </p>
          </div>
        ))}
      </section>

      {/* Service Agreements */}
      <section>
      <h2 className="text-xl font-semibold text-[#009efb] mb-4 border-b-2 border-[#009efb] pb-1">
          Service Agreements
        </h2>
        <div className="mb-5">
          <h3 className="text-lg font-medium text-gray-800 mb-1">
            Service Agreement List
          </h3>
          <p className="text-sm text-gray-600">
            Expired | Expiring This Month | Expiring Next Month | Open Ended | Custom
          </p>
        </div>
      </section>
    </div>
  </div>
</div>


  );
};

 

export default ReportDashboard;  
  
   
 